import { render, staticRenderFns } from "./Feriados.vue?vue&type=template&id=518d2a7f&scoped=true"
import script from "./Feriados.vue?vue&type=script&lang=js"
export * from "./Feriados.vue?vue&type=script&lang=js"
import style0 from "./Feriados.vue?vue&type=style&index=0&id=518d2a7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518d2a7f",
  null
  
)

export default component.exports